import { createBrowserRouter, RouteObject } from 'react-router-dom';
import { roleGuard } from './RoleGuard';
import PrivateRoutes from './PrivateRoute';
// import Index from '../pages/Index';
import Login from '../pages/Login/Login';
import Profile from '../pages/Profile/Profile';
import NotFound from '../pages/NotFound/NotFound';
import Register from '../pages/Register/Register';
import EditProfile from '../pages/Profile/EditProfile';
import Home from '../pages/Home/Home';
import ResetPassword from '../pages/ResetPassword/ResetPassword';
import CourseView from '../pages/Course/CourseView';
import Cart from '../pages/Cart/Cart';
import StudentEdit from '../pages/Student/StudentEdit';
import RegisterNew from '../pages/Register/RegisterNew';
import RegisterExist from '../pages/Register/RegisterExist';
import PaymentHistory from '../pages/PaymentHistory/PaymentHistory';
import ItemView from '../pages/Item/ItemView';
import Inbox from '../pages/Inbox/Inbox';
import InboxView from '../pages/Inbox/InboxView';
import ScheduleList from '../pages/Schedule/ScheduleList';
import AttendanceView from '../pages/Student/Attendance/AttendanceView';
import BranchCourse from '../pages/Branch/BranchCourse';
import LoginAsUser from '../pages/LoginAsUser/LoginAsUser';
import CourseEdit from '../pages/Course/CourseEdit';
// import { academyRoutes } from './AcademyRoute';

const routes: RouteObject[] = [
    { path: "login", element: <Login/> },
    { path: "register", element: <Register /> },
    { path: "register-new", element: <RegisterNew /> },
    { path: "register-exist", element: <RegisterExist /> },
    { path: "reset-password", element: <ResetPassword /> },
    { path: "login-as-user", element: <LoginAsUser /> },
    {
        path: "/",
        loader: roleGuard,
    },
    // ...academyRoutes
    {
        path: "/",
        element: <PrivateRoutes />,
        children: [
            { index: true, element: <Home />},
            { path: "profile",
                children: [
                    { index: true, element: <Profile /> },
                    { path: "edit", element: <EditProfile /> },
                ],
            },
            { path: "course",
                children: [
                    { path: ":id", element: <CourseView/> },
                    { path: ":id/edit", element: <CourseEdit/> },
                ],
            },
            { path: "item",
                children: [
                    { path: ":id", element: <ItemView/> },
                ],
            },
            { path: "cart",
                children: [
                    { index: true, element: <Cart /> },
                ],
            },
            { path: "children",
                children: [
                    { path: ":type/:id?", element: <StudentEdit /> },
                    { path: ":type/:id/attendance/:attendanceId", element: <AttendanceView /> }
                ],
            },
            { path: "payment-history",
                children: [
                    { index:true, element: <PaymentHistory /> }
                ],
            },
            { path: "inbox",
                children: [
                    { index:true, element: <Inbox /> },
                    { path: ":id", element: <InboxView /> }
                ],
            },
            { path: "schedule",
                children: [
                    { index:true, element: <ScheduleList/> },
                ],
            },
            { path: "branch",
                children: [
                    { path: ":branchId", element: <BranchCourse/> },
                ],
            },
            // { path: "schedule",
            //     children: [
            //         { index: true, element: <ScheduleView /> },
            //         { path: ":id", element: <AttendanceView /> },
            //     ],
            // },
        ],
    },
    { path: "*", element: <NotFound/> }
];

const router = createBrowserRouter(routes)

export default router;
